import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IResizedColumn } from '../../common/models/table';
import { IColumnDefinition } from '../../common/models/column-definition';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';

@Injectable()
export class LandlordTableColumnsHttpService {

  constructor(private http: HttpClient,
    private urlBuilderService: UrlBuilderService) { }

  getLandlordTableColumns(): Observable<IColumnDefinition[]> {
    const url = this.urlBuilderService.getUrl('landlords/table/availablecolumns');
    return this.http
      .get<IColumnDefinition[]>(url).pipe(
        map(table => table || undefined)
      );
  }

  putLandlordTableColumns(payload: IColumnDefinition[]): Observable<any> {
    const url = this.urlBuilderService.getUrl('landlords/table/updatecolumns');
    return this.http
      .put(url, payload, { responseType: 'text' });
  }

  reorderLandlordTableColumns(payload: string[]): Observable<any> {
    const url = this.urlBuilderService.getUrl('landlords/table/reordercolumns');
    return this.http
      .put(url, payload, { responseType: 'text' });
  }

  setTableDefaultColumns(): Observable<any> {
    const url = this.urlBuilderService.getUrl('landlords/table/setdefault');
    return this.http
      .put(url, [], { responseType: 'text' });
  }

  resizeColumns(payload: IResizedColumn): Observable<any> {
    const url = this.urlBuilderService.getUrl('landlords/table/resizecolumns');
    return this.http
      .put(url, payload, { responseType: 'text' });
  }

}
